<div class="simple-select">
    <label *ngIf="label" for="simple-select">{{ label }}</label>

    <div class="select-wrapper" [class.no-border]="noBorder">
        <select #selectElement name="simple-select" id="simple-select" 
                (change)="onSelect($event)" 
                [value]="selectedOption"
                [attr.aria-label]="effectiveAriaLabel">
            <option *ngFor="let option of options" [value]="option.value" [selected]="matchSelectedOption(option)" [disabled]="option.disabled">{{ option.label }}</option>
        </select>
        <lucide-icon aria-label="chevron down icon" role="img" [img]="chevronDownIcon" (click)="onIconClick()" class="select-icon" size="16"></lucide-icon>
    </div>
</div>